import { module as BaseModule } from 'modujs'
import { loadScript } from '../utils/dom'

const SCRIPT_ORDER = ['jquery', 'pannellum', 'libpannellum', 'owl', 'jqueryCookie', 'wpvr']

const GLOBAL_CHECKS = {
  jquery: () => window.jQuery,
  pannellum: () => window.pannellum,
  wpvr: () => typeof window.wpvrhotspot === 'function',
}

export default class extends BaseModule {
  async init() {
    if (!this.el.querySelector('.wpvr-cardboard, [id^="pano"]')) {
      return
    }

    if (this.el.querySelector('.pnlm-container')) {
      return
    }

    const assets = JSON.parse(this.el.dataset.wpvrAssets || 'null')
    if (!assets) {
      return
    }

    if (!window.wpvr_public && this.el.dataset.wpvrConfig) {
      window.wpvr_public = JSON.parse(this.el.dataset.wpvrConfig)
    }

    await this.loadDependencies(assets)
    this.runInlineScripts(this.el)
  }

  async loadDependencies(assets) {
    for (const key of SCRIPT_ORDER) {
      const url = assets[key]
      if (!url) {
        continue
      }

      const isLoaded = GLOBAL_CHECKS[key]?.()
      if (isLoaded) {
        continue
      }

      await loadScript(url, false)
    }
  }

  runInlineScripts(container) {
    container.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script')

      Array.from(oldScript.attributes).forEach((attr) => {
        script.setAttribute(attr.name, attr.value)
      })

      script.textContent = oldScript.textContent
      oldScript.replaceWith(script)
    })
  }
}
